/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const overlayNoRowsTemplate = 'There are no records to display.';

const colDefs = [
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: false,
        filter: false,
        width: 150,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/order/transaction-log?ordernumber=${params.value}`}>{params.value}</Link> );

        }
    },
    {
        field: 'buildWeek',
        headerName: 'Build Week',
        sortable: true,
        filter: true,
        width: 150,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = new Date( params.value ).toISOString().substring( 0, 10 );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'qty',
        headerName: 'Qty',
        sortable: true,
        filter: true,
        width: 80
    }
];

const OpenActivityAfterRealllocationTable = props => (

    <section className="atp-search-result-panel order-open-activity-after-reallocation-result-panel">
        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
                overlayNoRowsTemplate={overlayNoRowsTemplate}
            />
        </div>

    </section>
);

OpenActivityAfterRealllocationTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default OpenActivityAfterRealllocationTable;
